import { MouseEvent } from "react";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/Add";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import UndoIcon from "@mui/icons-material/Undo";
import { UNIT_TEXT } from "../DailyExpense/constants";
import { VIEW_OPTIONS } from "./constants";
import { AmountView } from "./monthlyExpenseMath";

interface CloseToolbarProps {
  view: AmountView;
  isEditable: boolean;
  hasPreviousItems: boolean;
  hasAdjustments: boolean;
  onViewChange: (view: AmountView) => void;
  onAddExtra: () => void;
  onCopyPrevious: () => void;
  onRoundUp: () => void;
  onRevertAll: () => void;
}

const isAmountView = (value: unknown): value is AmountView =>
  VIEW_OPTIONS.some((option) => option.value === value);

/** ยอดเดือน / รายวัน / รายสาย, and the adjustment tools of an open month. */
export default function CloseToolbar({
  view,
  isEditable,
  hasPreviousItems,
  hasAdjustments,
  onViewChange,
  onAddExtra,
  onCopyPrevious,
  onRoundUp,
  onRevertAll,
}: Readonly<CloseToolbarProps>) {
  const handleViewChange = (_event: MouseEvent<HTMLElement>, next: unknown) => {
    if (isAmountView(next)) onViewChange(next);
  };
  const hint = VIEW_OPTIONS.find((option) => option.value === view)?.hint;

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" gap={1.5} flexWrap="wrap" mb={1.5}>
      <Stack direction="row" alignItems="center" gap={1.5} flexWrap="wrap">
        <ToggleButtonGroup exclusive size="small" value={view} onChange={handleViewChange}>
          {VIEW_OPTIONS.map((option) => (
            <ToggleButton key={option.value} value={option.value}>
              {option.label}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
        <Typography variant="body2" color="text.secondary">
          {UNIT_TEXT} · {hint}
        </Typography>
      </Stack>
      {isEditable && (
        <Stack direction="row" gap={1} flexWrap="wrap">
          <Button variant="outlined" startIcon={<AddIcon />} onClick={onAddExtra}>
            เพิ่มค่าใช้จ่าย
          </Button>
          <Button color="inherit" variant="outlined" startIcon={<ContentCopyIcon />} disabled={!hasPreviousItems} onClick={onCopyPrevious}>
            คัดลอกยอดเดือนก่อน
          </Button>
          <Button color="inherit" variant="outlined" onClick={onRoundUp}>
            ปัดขึ้นเป็นจำนวนเต็ม
          </Button>
          <Button color="inherit" variant="outlined" startIcon={<UndoIcon />} disabled={!hasAdjustments} onClick={onRevertAll}>
            คืนค่าระบบทั้งหมด
          </Button>
        </Stack>
      )}
    </Stack>
  );
}
